import React from 'react';
import PropTypes from 'prop-types';
import HighlightedCommentaryCard
  from 'Components/ComponentLibrary/Organisms/AccountPerformanceCommentaryCard/CommentaryCardPicker/HighlightedCommentaryCard/HighlightedCommentaryCard';
import NonHighlightedCommentaryCard
  from 'Components/ComponentLibrary/Organisms/AccountPerformanceCommentaryCard/CommentaryCardPicker/NonHighlightedCommentaryCard/NonHighlightedCommentaryCard';

const CommentaryCardPicker = ({
  isHighlight,
  ...rest
}) => {
  if (isHighlight) {
    return (<HighlightedCommentaryCard {...rest} />);
  }

  return (<NonHighlightedCommentaryCard {...rest} />);
};

CommentaryCardPicker.propTypes = {
  isHighlight: PropTypes.bool.isRequired,
};

export default CommentaryCardPicker;
